<template>
  <ScheduledConsultationBanner
    v-if="isScheduledConsultation(consultation)"
    :consultation="consultation"
  />

  <DirectConsultationBanner v-else :consultation="consultation" />
</template>

<script setup lang="ts">
import { type ConsultationRequestDTO, type ScheduledConsultationDTO } from '@/generated'
import ScheduledConsultationBanner from '@/components/consultationrequest/ScheduledConsultationBanner.vue'
import DirectConsultationBanner from '@/components/consultationrequest/DirectConsultationBanner.vue'
import { isScheduledConsultation } from '@/util/isScheduledConsultation'

interface Props {
  consultation: ScheduledConsultationDTO | ConsultationRequestDTO
}

const { consultation } = defineProps<Props>()
</script>

<style scoped></style>
